import { Component, Input, OnInit } from '@angular/core';
import { ServiceProvider } from '@gms/tsp-api';
import { select, Store } from '@ngrx/store';
import { IAppState } from 'app/store/app/app.state';
import { selectRouteConfigs } from 'app/store/auth/auth.selectors';
import { getSelectedInfoPostTSP } from 'app/store/infopost/infopost.selectors';
import { IInfoPostState } from 'app/store/infopost/infopost.state';
import { SetSelectedPrimaryNavConfig } from 'app/store/sidebar/sidebar.actions';
import {
  selectActivePrimaryNavMenuId,
  selectSelectedPrimaryNavConfig,
} from 'app/store/sidebar/sidebar.selectors';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { HasSubscriptions } from 'shared/components/higher-order/has-subscriptions';
import { LABELS } from 'shared/consts/labels.const';
import { InfoPostNavConfig } from '../sidebar-nav/nav-menus.constants';
import { Router } from '@angular/router';
import { SidebarService } from 'shared/services/sidebar.service';

@Component({
  selector: 'app-infopost-sidebar-nav-item',
  templateUrl: './sidebar-nav-item.component.html',
  styleUrls: ['./sidebar-nav-item.component.scss'],
})
export class InfoPostSidebarNavItemComponent extends HasSubscriptions implements OnInit {
  @Input()
  config: InfoPostNavConfig;

  @Input() menuItemType: string = "";

  @Input()
  menuGuards: { [name: string]: Observable<boolean> };

  isAccessPage: boolean = false;
  isDisplayArrowIcon:boolean;

  selectedPrimaryNavConfig$ = this._store.pipe(select(selectSelectedPrimaryNavConfig));
  activePrimaryNavMenuId$ = this._store.pipe(select(selectActivePrimaryNavMenuId));
  routeConfigs$ = this._store.pipe(
    select(selectRouteConfigs),
    filter(Boolean)
  );

  headerState$: Observable<ServiceProvider> = this._infoStore.pipe(select(getSelectedInfoPostTSP));

  constructor(private _store: Store<IAppState>, private sharedService: SidebarService,
    private _infoStore: Store<IInfoPostState>, private _router: Router) {
    super();
  }

  ngOnInit() {

    this.isDisplayArrowIcon = this._router.url?.includes(LABELS.BISA_ROUTE_URL);
    
    this.addSubscriptions([
      this.headerState$.subscribe(resp => {
        this.isAccessPage = resp && Object.keys(resp).length > 0 || this.config.route === '/home';
      })
    ])
  }

  triggerSubMenu(e, config?: string): void {
    this.sharedService.isAccessPage(this.isAccessPage);
    if (!this.isAccessPage && this.menuItemType === LABELS.MENU_TYPE_MAIN) {
      return
    }
    else if (config && this.config?.route)
      this._router.navigate([this.config.route]);

    if (e) {
      e.stopPropagation();
      this._store.dispatch(new SetSelectedPrimaryNavConfig(this.config));
    } else {
      this._store.dispatch(new SetSelectedPrimaryNavConfig(null));
    }
  }
}
